import React, { useState, useEffect } from "react";
import { Button, InputGroup, Dropdown, DropdownButton, Form, Accordion, Tabs, Tab, Row, Col } from "react-bootstrap";
import { VIEW_SETTING_URL } from "../../../../Constant/api";
import { authService } from "../../../../Service/Axios";

const PageBreak = ({ status, setsettings, eleavailable, viewForm, setviewSetting, settings, setpagebk, allElements, formId, setcounter, counter, setviewForm, dynaDDselarr }) => {

    const handleDelete = (ID) => {
        setpagebk(allElements.filter(item => item.pageId != ID))
    }

    const [flagPg, setflagPg] = useState(null);

    useEffect(() => {
        if (!settings) setflagPg(null)
    }, [settings])

    const handleSetting = () => {
        viewSettingAction()
    }

    const viewSettingAction = async () => {

        const payload = { "formId": formId, "questionId": viewForm, "elementType": counter, "sequenceNo": dynaDDselarr };
        const response = await authService(VIEW_SETTING_URL, "POST", payload);
        if (response) {
            setviewSetting(response)
        }
        setsettings(!settings)
    };

    return (
        <Col className="mt-2 mb-2" xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
            <div className={`${(status == `preview` ||
                status == `In Progress` ||
                status == `Submitted` ||
                status == "Published") && !viewForm[0]?.internal
                ? `builder-row border rounded-2 bg-light preview-field`
                : (status == `preview` ||
                    status == `In Progress` ||
                    status == `Submitted` ||
                    status == "Published") && viewForm[0]?.internal ?
                    `builder-row border rounded-2 bg-light preview-field d-none` : flagPg == viewForm ? `builder-row border rounded-2 bg-light active` : `builder-row border rounded-2 bg-light`}`}>
                <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                    <h4><span className="material-symbols-outlined align-middle me-2 pluto-section"></span> Page Breaker</h4>
                    <div className="button-list ms-auto d-flex">
                        <Button variant="transparent"><span className="material-symbols-outlined align-middle copy-btn me-2" onClick={(e) => { setflagPg(viewForm); handleSetting(); }}>settings</span></Button>
                        <Button variant="transparent"><span className="material-symbols-outlined align-middle remove-btn" onClick={(e) => handleDelete(viewForm)}>delete</span></Button>
                    </div>
                </div>
                <div className="builder-row-body d-flex flex-wrap">
                    <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent"><span className="material-symbols-outlined">drag_indicator</span></Button>
                    </div>
                    <div className="builder-field p-3">
                        {(status == "preview" || status == "In Progress" || status == `Submitted` || status == "Published") ?
                            <div className="text-center">
                                {dynaDDselarr > 0 && <Button variant="dark btn-lg" onClick={() => setcounter(counter - 1)}>Back</Button>}{" "}
                                {dynaDDselarr < eleavailable.length - 1 && <Button variant="primary btn-lg" onClick={() => setcounter(counter + 1)}>Next</Button>}
                            </div>
                            :
                            <div className="text-center" style={{ pointerEvents: "none" }}>
                                {dynaDDselarr > 0 && <Button variant="dark btn-lg">Back</Button>}{" "}
                                {dynaDDselarr < allElements.length - 1 && <Button variant="primary btn-lg">Next</Button>}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Col>
    )
}

export default PageBreak